import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ResponseOutputItem, ResponseOutputRefusal, ResponseOutputText, RetriveConversazione, StoryChat } from '../components/new-nica-ai/ai-interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NicaChatAiService {
  private conversazione: BehaviorSubject<StoryChat[]> = new BehaviorSubject<StoryChat[]>([])
  private loading: Subject<boolean> = new Subject<boolean>()
  private error: Subject<boolean> = new Subject<boolean>()
  private clearing: Subject<boolean> = new Subject<boolean>()
  conversazione$ = this.conversazione.asObservable();
  loading$ = this.loading.asObservable();
  clearing$ = this.clearing.asObservable();
  error$ = this.error.asObservable();
  constructor(private readonly http: HttpClient,) { }

  addMessage(msg: StoryChat[]) {
    const current = this.conversazione.value;
    this.conversazione.next([...current, ...msg]);
    this.callChat(msg)
  }

  clear() {
    this.clearing.next(true);
    return this.http.delete(`${environment.END_POINT_AI}conversazione`).pipe(take(1)).subscribe({
      next: (res: any) => {
        if (!res || res.error === true) {
          this.error.next(true);
        } else {
          this.conversazione.next([]);
          this.error.next(false);
        }
      },
      error: (err) => {
        console.error(err);
        this.error.next(true);
      },
      complete: () => this.clearing.next(false)
    });
  }


  retriveConversazione() {
    this.clearing.next(true);
    return this.http.get(`${environment.END_POINT_AI}conversazione`)
      .pipe(
        take(1),
        tap((res) => this.processConversazione(res)),
        tap(() => this.clearing.next(false)),
        tap(() => this.error.next(false)),
      );
  }

  reprocessData() {
    const conversazione = this.conversazione.value
    conversazione.forEach((val, index) => {
      if (val.metadata) val.metadata.isProcessed = conversazione.length - 1 !== index

    })
  }

  private callChat(conversation: StoryChat[]) {
    this.loading.next(true)
    const body = { conversation, metadata: { scope: "RENTRINCLOUD" } };
    return this.http.post(`${environment.END_POINT_AI}chat`, body).pipe(take(1)).subscribe({
      next: (res: Record<any, any>) => {
        this.processChat(res)
      },
      error: (err) => {
        console.error(err);
        this.error.next(true)
      },
      complete: () => { this.loading.next(false) }
    });
  }

  private processChat(response: Record<any, any>) {
    if (!response || response.error === true) {
      this.error.next(true);
      return;
    }
    const output: Array<ResponseOutputItem & { created_at: string }> = response.data;
    for (const obj of output) {
      if (obj.type !== 'message' || !Array.isArray(obj.content)) continue;
      for (const cont of obj.content) {
        if (cont.type === 'refusal') continue;
        const hostId = new Date().getTime().toString()
        const data = cont.text
        const metadata = cont.text.includes('```json') ? { data, hostId, isProcessed: false } : undefined
        this.setConversazione({ content: cont.text, date: new Date(), role: 'assistant', metadata })
      }
    }
  }

  private processConversazione(response: Record<any, any>) {
    if (!response || response.error === true) {
      this.error.next(true);
      return;
    }
    const output: { conversazione: any, messaggi: Array<(ResponseOutputItem | { role: 'user', content: string }) & { created_at: Date }> } = response.data
    if (output.messaggi === null) return
    for (let i = 0; i < output.messaggi.length; i++) {
      const obj = output.messaggi[i]
      const isProcessed = output.messaggi.length - 1 !== i
      if ('role' in obj && obj.role === 'user') {
        this.setConversazione({ content: obj.content, role: obj.role, date: new Date(obj.created_at) })
      } else {
        if (obj.type !== 'message') return this.error.next(true);
        obj.content.forEach((cont: ResponseOutputText | ResponseOutputRefusal) => {
          if (cont.type === 'refusal') return this.error.next(true)
          const hostId = new Date((obj as any).created_at).getTime().toString()
          const data = cont.text
          const metadata = cont.text.includes('```json') ? { data, hostId, isProcessed } : undefined
          this.setConversazione({ content: cont.text, date: new Date((obj as any).created_at), role: 'assistant', metadata })
        })
      }

    }
  }

  private setConversazione({ content, date, role, metadata }: StoryChat) {
    const current = this.conversazione.value;
    this.conversazione.next([...current, {
      content,
      role,
      date,
      metadata
    }]);
    return
  }
}
